import {
  UPDATE_DP_SOA_ACTIVITIES,
  UPDATE_DP_FOOTNOTE_CONFIG_DATA,
  UPDATE_DP_FOOTNOTE_DATA,
  UPDATE_DP_FOOTNOTE_SOFT_SAVE,
  CLEAR_DP_FOOTNOTE_SOFT_SAVE,
  UPDATE_DP_FINALIZE_STATUS,
} from "src/DigitalProtocolModule/constants";

export function updateDPSoaActivities(payload) {
  return {
    type: UPDATE_DP_SOA_ACTIVITIES,
    payload,
  };
}

export function updateDPFootnoteConfigData(payload) {
  return {
    type: UPDATE_DP_FOOTNOTE_CONFIG_DATA,
    payload,
  };
}

export function updateDPFootnoteDataList(payload) {
  return {
    type: UPDATE_DP_FOOTNOTE_DATA,
    payload,
  };
}

export function updateDPFootnoteSoftSave(payload) {
  return {
    type: UPDATE_DP_FOOTNOTE_SOFT_SAVE,
    payload,
  };
}

export function clearDPFootnoteSoftSave() {
  return {
    type: CLEAR_DP_FOOTNOTE_SOFT_SAVE,
  };
}

export function updateFinalizeStatus(payload) {
  return {
    type: UPDATE_DP_FINALIZE_STATUS,
    payload,
  };
}
